module.exports = __webpack_public_path__ + "static/media/14.10eff8df.jpg";